var map = {
	"./aparthotelclub/ic_youtube_link_circle.png": 83968,
	"./beachful/ic_youtube_link_circle.png": 45107,
	"./castlepedia/ic_youtube_link_circle.png": 98638,
	"./cocktayl/ic_youtube_link_circle.png": 33160,
	"./ic_youtube_link_circle.png": 883,
	"./luxresortclub/ic_youtube_link_circle.png": 55106,
	"./parkful/ic_youtube_link_circle.png": 69674,
	"./prefabworld/ic_youtube_link_circle.png": 2329,
	"./rooftopclub/ic_youtube_link_circle.png": 87512,
	"./spaclub/ic_youtube_link_circle.png": 73664,
	"./worldcasino/ic_youtube_link_circle.png": 26577,
	"./zoopedia/ic_youtube_link_circle.png": 51347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66822;